//funciones que se pueden reutilizar, son mejores para no sobrecargar el componente

export function calcularTotal(nota, ponderacion) {
  
  const notaPresentacion=nota*ponderacion/100;
  const nota4 = 4;
  const restantePonderacion= 100-ponderacion;
  const notaPasar=(nota4-notaPresentacion)/restantePonderacion*100;

  return notaPasar;

}
